/*
 * KS limit guard — 限購（Minmaxify 每單上限）全旅程
 *
 * 限購規則一律從 Minmaxify 讀（window.minMaxify.getLimitsFor），在 Minmaxify 後台
 * Product 分頁設定 Max 的商品自動套用，不用改這支檔案。
 *
 * 1. 加入購物車前先算：購物車已有 + 這次要加 > 上限 → 只加到上限（並提示），已滿 → 擋下並提示。
 * 2. 購物車內改數量：超過上限 → 自動改成上限並提示；下拉選單/＋ 只給到上限。
 * 3. 安全網：任何時候購物車超量（舊購物車、別的路徑加入）→ 自動調回上限並提示，
 *    所以結帳鈕不會再變成 Minmaxify 的「ORDER NOT VALID」。
 * 4. 商品頁：顯示「每單限購 N 組」；已達上限時按鈕改成「已達限購・查看購物車」。
 *
 * 只處理 Max；Min / Multiple 目前沒有商品使用，仍交給 Minmaxify。
 */
(function () {
  if (window.__ksLimitGuard) return;
  window.__ksLimitGuard = true;

  var ADD_RE = /\/cart\/add(\.js)?(\?|$)/;
  var CHANGE_RE = /\/cart\/change(\.js)?(\?|$)/;
  var UPDATE_RE = /\/cart\/update(\.js)?(\?|$)/;
  var CART_RE = /\/cart(\.js|\.json)(\?|$)/;
  var CACHE_KEY = 'ks-limit-guard:v1';

  var nativeFetch = window.fetch.bind(window);
  var cart = null; // 最近一次的 /cart.js
  var overLimitNow = false; // cart 是否超過任何 Max（setCart 時算好，避免在 observer 裡呼叫 Minmaxify）
  var handleCache = readCache(); // variant id -> handle

  /* ---------- Minmaxify ---------- */

  function mmReady() {
    var mm = window.minMaxify;
    if (!mm || typeof mm.getLimitsFor !== 'function') return false;
    try {
      return 'min' in (mm.getLimitsFor({ handle: '__ks_probe__' }) || {});
    } catch (e) {
      return false;
    }
  }

  function waitForMm(ms) {
    if (mmReady()) return Promise.resolve(true);
    return new Promise(function (resolve) {
      var start = Date.now();
      var t = setInterval(function () {
        if (mmReady()) {
          clearInterval(t);
          resolve(true);
        } else if (Date.now() - start > ms) {
          clearInterval(t);
          resolve(false);
        }
      }, 100);
    });
  }

  // { max, combine } 或 null（沒限購）
  function limitFor(item) {
    if (!mmReady() || !item || !item.handle) return null;
    var l;
    try {
      l = window.minMaxify.getLimitsFor({
        handle: item.handle,
        product_id: item.product_id,
        variant_id: item.variant_id,
        sku: item.sku || '',
      });
    } catch (e) {
      return null;
    }
    if (!l || !l.max) return null;
    return { max: Number(l.max), combine: !!l.combine };
  }

  function groupKey(item, limit) {
    return limit.combine ? 'h:' + item.handle : 'v:' + item.variant_id;
  }

  /* ---------- cart / variant lookups ---------- */

  function readCache() {
    try {
      return JSON.parse(sessionStorage.getItem(CACHE_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  function writeCache() {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify(handleCache));
    } catch (e) {}
  }

  function loadCart() {
    return nativeFetch('/cart.js?ks_limit=' + Date.now(), { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        setCart(c);
        return c;
      });
  }

  function setCart(c) {
    if (!c || !Array.isArray(c.items)) return;
    cart = c;
    overLimitNow = cartOverLimit(c);
    c.items.forEach(function (i) {
      if (i.variant_id && i.handle) handleCache[i.variant_id] = i.handle;
    });
    writeCache();
    scheduleDecorate();
  }

  function pdpProduct() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    var p = meta && meta.product;
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!p || !m) return null;
    var handle;
    try {
      handle = decodeURIComponent(m[1]);
    } catch (e) {
      handle = m[1];
    }
    return { id: p.id, handle: handle, title: (p.variants && p.variants[0] && p.variants[0].name) || '', variants: p.variants || [] };
  }

  // variant id -> { handle, product_id, variant_id, title }
  function resolveVariant(variantId) {
    variantId = Number(variantId);
    var line = cart && cart.items.find(function (i) {
      return i.variant_id === variantId;
    });
    if (line) return Promise.resolve(line);

    var pdp = pdpProduct();
    if (pdp && pdp.variants.some(function (v) { return Number(v.id) === variantId; })) {
      return Promise.resolve({ handle: pdp.handle, product_id: pdp.id, variant_id: variantId, product_title: productTitle() });
    }

    if (handleCache[variantId]) {
      return Promise.resolve({ handle: handleCache[variantId], variant_id: variantId });
    }

    // /variants/<id> 會轉址到 /products/<handle>?variant=<id>
    return nativeFetch('/variants/' + variantId, { credentials: 'same-origin' })
      .then(function (r) {
        var m = (r.url || '').match(/\/products\/([^/?#]+)/);
        if (!m) return null;
        var h = decodeURIComponent(m[1]);
        handleCache[variantId] = h;
        writeCache();
        return { handle: h, variant_id: variantId };
      })
      .catch(function () {
        return null;
      });
  }

  function productTitle() {
    var h = document.querySelector('.product__title, h1.product__title, [data-product-title], h1');
    return h ? h.textContent.trim() : '';
  }

  function shortTitle(t) {
    t = (t || '此商品').replace(/^KS秘密快閃專區-\s*/, '').trim();
    return t.length > 26 ? t.slice(0, 26) + '…' : t;
  }

  function qtyInGroup(key, limit, excludeKey) {
    if (!cart) return 0;
    return cart.items.reduce(function (sum, i) {
      if (excludeKey && i.key === excludeKey) return sum;
      var l = limitFor(i);
      return l && groupKey(i, limit) === key && groupKey(i, l) === key ? sum + i.quantity : sum;
    }, 0);
  }

  /* ---------- request bodies ---------- */

  function readBody(body) {
    if (body == null) return null;
    if (typeof body === 'string') {
      var s = body.trim();
      if (s.charAt(0) === '{') {
        try {
          return { kind: 'json', data: JSON.parse(s) };
        } catch (e) {
          return null;
        }
      }
      return { kind: 'params', data: new URLSearchParams(s) };
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData) return { kind: 'form', data: body };
    if (body instanceof URLSearchParams) return { kind: 'params', data: body };
    return null;
  }

  function writeBody(parsed) {
    if (parsed.kind === 'json') return JSON.stringify(parsed.data);
    if (parsed.kind === 'params') return parsed.data.toString();
    return parsed.data;
  }

  function getField(parsed, name) {
    if (parsed.kind === 'json') return parsed.data[name];
    var v = parsed.data.get(name);
    return v === null ? undefined : v;
  }

  function setField(parsed, name, value) {
    if (parsed.kind === 'json') parsed.data[name] = value;
    else parsed.data.set(name, String(value));
  }

  // 加入購物車的品項：[{ id, quantity, set(q) }]
  function addLines(parsed) {
    var out = [];
    if (parsed.kind === 'json' && Array.isArray(parsed.data.items)) {
      parsed.data.items.forEach(function (it) {
        out.push({ id: it.id, quantity: Number(it.quantity || 1), set: function (q) { it.quantity = q; this.quantity = q; } });
      });
      return out;
    }
    if (parsed.kind !== 'json') {
      var i = 0;
      while (parsed.data.has('items[' + i + '][id]')) {
        (function (n) {
          out.push({
            id: parsed.data.get('items[' + n + '][id]'),
            quantity: Number(parsed.data.get('items[' + n + '][quantity]') || 1),
            set: function (q) { parsed.data.set('items[' + n + '][quantity]', String(q)); this.quantity = q; },
          });
        })(i);
        i++;
      }
      if (out.length) return out;
    }
    var id = getField(parsed, 'id');
    if (id) {
      out.push({ id: id, quantity: Number(getField(parsed, 'quantity') || 1), set: function (q) { setField(parsed, 'quantity', q); this.quantity = q; } });
    }
    return out;
  }

  function errorResponse(message) {
    var body = JSON.stringify({ status: 422, message: message, description: message });
    return new Response(body, { status: 422, statusText: 'Unprocessable Entity', headers: { 'Content-Type': 'application/json' } });
  }

  /* ---------- preflight ---------- */

  function preflightAdd(parsed) {
    var lines = addLines(parsed);
    if (!lines.length) return Promise.resolve({ ok: true });

    return Promise.all([waitForMm(3000), loadCart().catch(function () { return null; })])
      .then(function () {
        return Promise.all(lines.map(function (l) { return resolveVariant(l.id); }));
      })
      .then(function (items) {
        var notes = [];
        var blocked = [];
        var used = {};
        lines.forEach(function (line, idx) {
          var item = items[idx];
          var limit = item && limitFor(item);
          if (!limit) return;
          var key = groupKey(item, limit);
          var inCart = qtyInGroup(key, limit) + (used[key] || 0);
          var room = Math.max(limit.max - inCart, 0);
          var title = shortTitle(item.product_title || item.title || productTitle());
          if (room <= 0) {
            line.set(0);
            blocked.push('「' + title + '」每單限購 ' + limit.max + ' 組，購物車內已有 ' + inCart + ' 組');
          } else if (line.quantity > room) {
            line.set(room);
            used[key] = (used[key] || 0) + room;
            notes.push('「' + title + '」每單限購 ' + limit.max + ' 組，已為你加入 ' + room + ' 組');
          } else {
            used[key] = (used[key] || 0) + line.quantity;
          }
        });

        if (blocked.length && !lines.some(function (l) { return l.quantity > 0; })) {
          return { ok: false, message: blocked[0] };
        }
        if (blocked.length && parsed.kind === 'json' && Array.isArray(parsed.data.items)) {
          parsed.data.items = parsed.data.items.filter(function (it) { return Number(it.quantity) > 0; });
        }
        return { ok: true, notes: blocked.concat(notes) };
      })
      .catch(function () {
        return { ok: true };
      });
  }

  function preflightChange(url, parsed) {
    return Promise.all([waitForMm(3000), loadCart().catch(function () { return null; })]).then(function () {
      if (!cart) return { ok: true };
      var notes = [];

      if (CHANGE_RE.test(url)) {
        var q = Number(getField(parsed, 'quantity'));
        if (!(q > 0)) return { ok: true };
        var id = getField(parsed, 'id');
        var lineNo = Number(getField(parsed, 'line'));
        var item = id != null
          ? cart.items.find(function (i) { return i.key === String(id) || String(i.variant_id) === String(id); })
          : cart.items[lineNo - 1];
        var limit = item && limitFor(item);
        if (!limit) return { ok: true };
        var allowed = limit.max - qtyInGroup(groupKey(item, limit), limit, item.key);
        if (q > allowed) {
          var nq = Math.max(allowed, 0);
          setField(parsed, 'quantity', nq);
          notes.push('「' + shortTitle(item.product_title) + '」每單限購 ' + limit.max + ' 組，數量已調整為 ' + nq + ' 組');
        }
        return { ok: true, notes: notes };
      }

      // /cart/update {updates: {key|variant: qty}} 或 [qty, qty, ...]
      var updates = parsed.kind === 'json' ? parsed.data.updates : null;
      if (!updates) return { ok: true };
      var next = cart.items.map(function (i, idx) {
        var v = Array.isArray(updates) ? updates[idx] : (updates[i.key] != null ? updates[i.key] : updates[i.variant_id]);
        return v == null ? i.quantity : Number(v);
      });
      var groups = {};
      cart.items.forEach(function (i, idx) {
        var l = limitFor(i);
        if (!l) return;
        var k = groupKey(i, l);
        (groups[k] = groups[k] || { limit: l, idx: [] }).idx.push(idx);
      });
      Object.keys(groups).forEach(function (k) {
        var g = groups[k];
        var total = g.idx.reduce(function (s, idx) { return s + next[idx]; }, 0);
        var over = total - g.limit.max;
        if (over <= 0) return;
        g.idx.forEach(function (idx) {
          if (over <= 0) return;
          var cut = Math.min(over, Math.max(next[idx] - 0, 0));
          next[idx] -= cut;
          over -= cut;
          var i = cart.items[idx];
          if (Array.isArray(updates)) updates[idx] = next[idx];
          else updates[updates[i.key] != null ? i.key : i.variant_id] = next[idx];
          if (updates[i.key] == null && updates[i.variant_id] == null && !Array.isArray(updates)) updates[i.key] = next[idx];
        });
        notes.push('「' + shortTitle(cart.items[g.idx[0]].product_title) + '」每單限購 ' + g.limit.max + ' 組，數量已調整');
      });
      return { ok: true, notes: notes };
    });
  }

  /* ---------- fetch / XHR hooks ---------- */

  function urlOf(input) {
    return String((input && input.url) || input || '');
  }

  window.fetch = function (input, init) {
    var url = urlOf(input);
    var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    var self = this;
    var args = arguments;

    var isAdd = method === 'POST' && ADD_RE.test(url);
    var isChange = method === 'POST' && (CHANGE_RE.test(url) || UPDATE_RE.test(url));
    var parsed = (isAdd || isChange) && init && !init.ksLimitBypass ? readBody(init.body) : null;

    if (!parsed) return passThrough(self, args, url);

    var pre = isAdd ? preflightAdd(parsed) : preflightChange(url, parsed);
    return pre.then(function (res) {
      if (!res.ok) {
        notify(res.message, { cartLink: true });
        renderPdp();
        return errorResponse(res.message);
      }
      var newInit = Object.assign({}, init, { body: writeBody(parsed) });
      return passThrough(self, [input, newInit], url).then(function (r) {
        if (res.notes && res.notes.length && r.ok) {
          setTimeout(function () { notify(res.notes.join('\n'), { cartLink: isAdd }); }, 60);
        }
        return r;
      });
    });
  };

  // 交給包裝前的 fetch（Minmaxify 不論包在我們裡面或外面都照樣看得到購物車回應）
  function passThrough(self, args, url) {
    var isMut = ADD_RE.test(url) || CHANGE_RE.test(url) || UPDATE_RE.test(url);
    if (isMut) mutationStart();
    var p = nativeFetch.apply(self, args);
    if (isMut) p.then(mutationEnd, mutationEnd);
    if (CART_RE.test(url) || CHANGE_RE.test(url) || UPDATE_RE.test(url) || ADD_RE.test(url)) {
      p.then(function (r) {
        if (!r.ok) return;
        if (ADD_RE.test(url)) {
          scheduleReconcile();
          return;
        }
        r.clone().json().then(function (c) {
          setCart(c);
          scheduleReconcile();
        }).catch(function () {});
      }).catch(function () {});
    }
    return p;
  }

  // XHR 加入/修改（例如舊的 jQuery 路徑）：事後檢查
  var xo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    this.__ksUrl = String(u || '');
    return xo.apply(this, arguments);
  };
  var xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var x = this;
    if (/\/cart\/(add|change|update)/.test(x.__ksUrl || '')) {
      mutationStart();
      x.addEventListener('loadend', function () {
        mutationEnd();
        scheduleReconcile();
      });
    }
    return xs.apply(this, arguments);
  };

  /* ---------- reconcile（安全網） ---------- */

  var reconcileTimer = null;
  var reconciling = false;
  function scheduleReconcile() {
    clearTimeout(reconcileTimer);
    reconcileTimer = setTimeout(reconcile, 30);
  }

  var reconcilePromise = null;
  function reconcile(opts) {
    if (reconciling && reconcilePromise) return reconcilePromise;
    var seen = -1;
    reconcilePromise = waitForMm(4000).then(function (ok) {
      if (!ok) {
        verifyDone();
        return false;
      }
      // 只有「所有已送出的變動都回來之後」才開始的檢查，才能解除 pendingVerify
      seen = mutDone === mutSent ? mutSent : -1;
      return loadCart().then(function (c) {
        var groups = {};
        c.items.forEach(function (i) {
          var l = limitFor(i);
          if (!l) return;
          var k = groupKey(i, l);
          (groups[k] = groups[k] || { limit: l, items: [], title: i.product_title }).items.push(i);
        });
        var updates = {};
        var notes = [];
        Object.keys(groups).forEach(function (k) {
          var g = groups[k];
          var total = g.items.reduce(function (s, i) { return s + i.quantity; }, 0);
          var over = total - g.limit.max;
          if (over <= 0) return;
          // cart.items 新的在前 → 先減最新加入的
          g.items.forEach(function (i) {
            if (over <= 0) return;
            var cut = Math.min(over, i.quantity);
            updates[i.key] = i.quantity - cut;
            over -= cut;
          });
          notes.push('「' + shortTitle(g.title) + '」每單限購 ' + g.limit.max + ' 組，購物車已自動調整為 ' + g.limit.max + ' 組，可直接結帳');
        });
        if (!notes.length) {
          verifyDone(seen);
          return false;
        }
        reconciling = true;
        fixingSince = Date.now();
        restoreCheckoutLabels();
        return window
          .fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: updates }),
            ksLimitBypass: true,
          })
          .then(function (r) { return r.json(); })
          .then(function (nc) {
            setCart(nc);
            document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
            notify(notes.join('\n') + (opts && opts.toCheckout ? '\n正在前往結帳…' : ''), { cartLink: false });
            return true;
          })
          .finally(function () {
            reconciling = false;
            verifyDone(seen);
          });
      });
    }).catch(function () { reconciling = false; verifyDone(); return false; });
    return reconcilePromise;
  }

  function cartOverLimit(c) {
    if (!c || !mmReady()) return false;
    var totals = {};
    return c.items.some(function (i) {
      var l = limitFor(i);
      if (!l) return false;
      var k = groupKey(i, l);
      totals[k] = (totals[k] || 0) + i.quantity;
      return totals[k] > l.max;
    });
  }

  /* ---------- 取代 Minmaxify 的「Order not valid」 ----------
   * 只在「超過 Max」這種我們能自己修好的情況接手：
   * 結帳鈕文字維持原樣（不閃 Order not valid / Verifying），
   * 按結帳時若仍超量 → 先自動調整、提示，再直接前往結帳（不跳 Minmaxify 的 alert）。
   * 其他類型的違規（Min / Multiple，目前沒用）照舊交給 Minmaxify。 */

  var CHECKOUT_LABEL = '[name=checkout], .checkout_button_label';
  var MM_LABEL_RE = /order not valid|verifying|cart needs to be updated/i;
  var fixingSince = 0;
  var pendingVerify = false; // 購物車剛變動、還在確認是否超量（Minmaxify 會比我們早一步判定）
  var mutSent = 0; // 送出的 add/change/update 數
  var mutDone = 0; // 已回應的數

  var pendingSince = 0;
  function mutationStart() {
    mutSent++;
    pendingVerify = true;
    pendingSince = Date.now();
  }
  function mutationEnd() {
    mutDone++;
  }

  function verifyDone(seenSeq) {
    if (seenSeq !== undefined && (seenSeq < 0 || seenSeq !== mutSent)) return;
    pendingVerify = false;
    // 確認完不是 Max 的問題，但 Minmaxify 仍判定無效 → 把它的訊息還回去，不吃掉真正的問題
    setTimeout(function () {
      if (maxIssueActive()) return;
      var mm = window.minMaxify;
      var stillInvalid = mm && typeof mm.checkLimits === 'function' && !mm.checkLimits();
      document.querySelectorAll(CHECKOUT_LABEL).forEach(function (el) {
        if (!el.__ksMasked) return;
        if (stillInvalid) {
          if (el.value) el.value = el.__ksMasked;
          if (el.tagName !== 'INPUT' && !el.childElementCount) el.textContent = el.__ksMasked;
        }
        el.__ksMasked = null;
      });
    }, 600);
  }

  function maxIssueActive() {
    return pendingVerify || reconciling || Date.now() - fixingSince < 3000 || overLimitNow;
  }

  var lastGoodLabel = '';
  function rememberLabel(el) {
    var t = (el.value || el.textContent || '').trim();
    if (t && !MM_LABEL_RE.test(t)) {
      el.setAttribute('data-ks-label', t);
      lastGoodLabel = t;
    }
  }

  function restoreCheckoutLabels() {
    document.querySelectorAll(CHECKOUT_LABEL).forEach(function (el) {
      var t = ((el.tagName === 'INPUT' ? el.value : el.textContent) || '') + ' ' + (el.value || '');
      t = t.trim();
      // 抽屜重繪後的新按鈕還沒被我們看過 → 用 Minmaxify 自己存的原文字，再不行用頁面上最後一個正常文字
      var orig = el.getAttribute('data-ks-label') || el.minMaxifySavedLabel || lastGoodLabel;
      if (!MM_LABEL_RE.test(t)) {
        rememberLabel(el);
        return;
      }
      if (!orig || !maxIssueActive()) return;
      el.__ksMasked = (el.value || el.textContent || '').trim();
      if (el.value && el.value !== orig) el.value = orig;
      if (el.tagName !== 'INPUT' && !el.childElementCount && el.textContent.trim() !== orig) {
        el.textContent = orig;
      }
      el.classList.remove('btn--loading');
    });
  }

  // 在 observer callback 裡直接改（畫面重繪前），Order not valid 不會出現在畫面上。
  // 只在文字是 Minmaxify 的訊息時才寫入、判斷只看快取旗標 → 不會互相觸發成無窮迴圈。
  var inLabelCheck = false;
  function queueLabelCheck() {
    if (inLabelCheck) return;
    inLabelCheck = true;
    try {
      restoreCheckoutLabels();
    } finally {
      inLabelCheck = false;
    }
  }
  new MutationObserver(queueLabelCheck).observe(document.documentElement, { subtree: true, childList: true, characterData: true });
  // input 的 value 是屬性改不會觸發 observer → 修正期間每 100ms 再看一次
  setInterval(function () {
    if (pendingVerify && Date.now() - pendingSince > 6000) verifyDone(); // 保險：最多遮 6 秒
    if (pendingVerify || reconciling || Date.now() - fixingSince < 3000) restoreCheckoutLabels();
  }, 100);

  var CHECKOUT_BTN = "[name=checkout], [href='/checkout'], form[action='/checkout'] [type=submit], .checkout_button, .btn-checkout";
  var goingCheckout = false;

  // 先把超量調好、說明，再直接前往結帳
  function fixThenCheckout() {
    if (goingCheckout) return;
    goingCheckout = true;
    reconcile({ toCheckout: true })
      .then(function (fixedNow) {
        return loadCart().then(function (c) {
          if (cartOverLimit(c)) {
            goingCheckout = false; // 修不好就不硬闖
            return;
          }
          if (!fixedNow) notify('購物車數量已符合限購，正在前往結帳…', { cartLink: false });
          setTimeout(function () { location.href = '/checkout'; }, 900);
        });
      })
      .catch(function () { goingCheckout = false; });
  }

  // 我們的 click 比 Minmaxify 先跑到時：直接接手
  window.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest(CHECKOUT_BTN);
      if (!btn || !maxIssueActive()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      fixThenCheckout();
    },
    true
  );

  // Minmaxify 先攔到結帳 click 時，它會呼叫 showPopup 顯示「Cannot place order…」→
  // 若原因是我們能修的 Max，就不跳它的視窗，改走 fixThenCheckout
  function hookMinmaxifyPopup() {
    var mm = window.minMaxify;
    if (!mm || mm.__ksPopupHooked || typeof mm.showPopup !== 'function') return;
    var orig = mm.showPopup;
    mm.showPopup = function () {
      if (maxIssueActive()) {
        fixThenCheckout();
        return true; // 告訴 Minmaxify 已處理，不要 alert
      }
      return orig.apply(this, arguments);
    };
    mm.__ksPopupHooked = true;
  }

  /* ---------- UI: toast ---------- */

  var toastEl, toastTimer;
  function notify(msg, opts) {
    if (!msg) return;
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'ks-limit-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '';
    var icon = document.createElement('span');
    icon.className = 'ks-limit-toast__icon';
    icon.textContent = '!';
    var text = document.createElement('span');
    text.className = 'ks-limit-toast__text';
    text.textContent = msg;
    toastEl.appendChild(icon);
    toastEl.appendChild(text);
    if (opts && opts.cartLink && !drawerIsOpen()) {
      var a = document.createElement('button');
      a.type = 'button';
      a.className = 'ks-limit-toast__link';
      a.textContent = '查看購物車';
      a.addEventListener('click', function () {
        hideToast();
        openDrawer();
      });
      toastEl.appendChild(a);
    }
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 5000);
  }

  function hideToast() {
    if (toastEl) toastEl.classList.remove('is-visible');
  }

  function drawerIsOpen() {
    var d = document.querySelector('cart-drawer');
    return !!(d && (d.hasAttribute('open') || d.classList.contains('is-open') || d.classList.contains('drawer--visible')));
  }

  function openDrawer() {
    var link = document.querySelector('a[href="/cart"], a[href="' + ((window.theme && theme.routes && theme.routes.cart_url) || '/cart') + '"]');
    if (link) link.click();
    else location.href = '/cart';
  }

  /* ---------- UI: cart drawer lines ---------- */

  var decorateTimer;
  function scheduleDecorate() {
    clearTimeout(decorateTimer);
    decorateTimer = setTimeout(function () {
      decorateLines();
      renderPdp();
    }, 50);
  }

  function decorateLines() {
    if (!cart || !mmReady()) return;
    document.querySelectorAll('[data-item]').forEach(function (row) {
      var key = row.getAttribute('data-item');
      var item = cart.items.find(function (i) { return i.key === key; });
      var limit = item && limitFor(item);
      var old = row.querySelector('.ks-limit-chip');
      if (!limit) {
        if (old) old.remove();
        return;
      }
      var allowed = limit.max - qtyInGroup(groupKey(item, limit), limit, item.key);
      var atMax = item.quantity >= allowed;

      var chip = old || document.createElement('div');
      chip.className = 'ks-limit-chip' + (atMax ? ' is-max' : '');
      chip.textContent = atMax ? '每單限購 ' + limit.max + ' 組・已達上限' : '每單限購 ' + limit.max + ' 組';
      if (!old) {
        var anchor = row.querySelector('.cart__quantity-wrapper, quantity-input');
        if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(chip, anchor);
        else row.appendChild(chip);
      }

      // 下拉選單：超過上限的選項不顯示
      row.querySelectorAll('[data-popout-option]').forEach(function (opt) {
        var v = Number(opt.getAttribute('data-value'));
        var li = opt.closest('li') || opt;
        li.style.display = v > allowed ? 'none' : '';
      });
      // ＋／數字欄
      var plus = row.querySelector('.cart__quantity-plus');
      if (plus) {
        plus.disabled = atMax;
        plus.classList.toggle('ks-limit-disabled', atMax);
      }
      var field = row.querySelector('.cart__quantity-field');
      if (field) field.max = Math.max(allowed, 1);
    });
  }

  /* ---------- UI: product page ---------- */

  function renderPdp() {
    var pdp = pdpProduct();
    if (!pdp || !mmReady()) return;
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var btn = form.querySelector('[name="add"], [data-add-to-cart]');
      var idInput = form.querySelector('[name="id"]');
      if (!btn || !idInput) return;
      var item = { handle: pdp.handle, product_id: pdp.id, variant_id: Number(idInput.value) };
      var limit = limitFor(item);
      var wrap = btn.closest('.product__submit__item') || btn.parentNode;
      var note = form.parentNode.querySelector('.ks-limit-note[data-form="' + form.id + '"]');
      if (!limit) {
        if (note) note.remove();
        setReached(btn, false);
        return;
      }
      var inCart = qtyInGroup(groupKey(item, limit), limit);
      var room = Math.max(limit.max - inCart, 0);
      if (!note) {
        note = document.createElement('p');
        note.className = 'ks-limit-note';
        note.setAttribute('data-form', form.id);
        wrap.parentNode.insertBefore(note, wrap.nextSibling);
      }
      note.classList.toggle('is-max', room === 0);
      note.textContent = room === 0
        ? '每單限購 ' + limit.max + ' 組・購物車內已有 ' + inCart + ' 組'
        : inCart > 0
          ? '每單限購 ' + limit.max + ' 組・購物車內已有 ' + inCart + ' 組，還可加 ' + room + ' 組'
          : '每單限購 ' + limit.max + ' 組';

      var qty = document.querySelector('[name="quantity"][form="' + form.id + '"]') || form.querySelector('[name="quantity"]');
      if (qty) {
        qty.max = Math.max(room, 1);
        if (Number(qty.value) > Math.max(room, 1)) qty.value = Math.max(room, 1);
      }
      setReached(btn, room === 0);
    });
  }

  function setReached(btn, reached) {
    var label = btn.querySelector('[data-add-to-cart-text], .btn__text') || btn;
    if (reached) {
      if (!btn.hasAttribute('data-ks-limit-reached')) {
        btn.setAttribute('data-ks-limit-label', label.textContent);
        btn.setAttribute('data-ks-limit-reached', '');
      }
      label.textContent = '已達限購・查看購物車';
    } else if (btn.hasAttribute('data-ks-limit-reached')) {
      label.textContent = btn.getAttribute('data-ks-limit-label') || label.textContent;
      btn.removeAttribute('data-ks-limit-reached');
    }
  }

  // 已達上限的按鈕：直接打開購物車，不送出
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('[data-ks-limit-reached]');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      openDrawer();
    },
    true
  );

  // 換規格（不合併計算的商品）時重算
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('form[action*="/cart/add"], variant-selects, [data-product-form]')) {
      setTimeout(renderPdp, 120);
    }
  });

  // 除錯用（唯讀）
  window.__ksLimitState = function () {
    return { pendingVerify: pendingVerify, reconciling: reconciling, fixingAgo: Date.now() - fixingSince, overLimitNow: overLimitNow, lastGoodLabel: lastGoodLabel };
  };

  /* ---------- styles ---------- */

  var css =
    '.ks-limit-toast{position:fixed;left:16px;right:16px;margin:0 auto;width:max-content;bottom:108px;transform:translateY(16px);z-index:2147483000;display:flex;align-items:center;gap:10px;' +
    'max-width:min(460px,calc(100vw - 32px));box-sizing:border-box;padding:12px 16px;border-radius:12px;background:#2b2118;color:#fff;font-size:14px;line-height:1.45;' +
    'box-shadow:0 10px 30px rgba(0,0,0,.22);opacity:0;pointer-events:none;transition:opacity .2s ease,transform .2s ease;white-space:pre-line}' +
    '.ks-limit-toast.is-visible{opacity:1;transform:translateY(0);pointer-events:auto}' +
    '.ks-limit-toast__icon{flex:0 0 22px;height:22px;border-radius:50%;background:#f0a33a;color:#2b2118;font-weight:700;display:flex;align-items:center;justify-content:center;font-size:13px}' +
    '.ks-limit-toast__text{flex:1 1 auto}' +
    '.ks-limit-toast__link{flex:0 0 auto;background:none;border:0;color:#f6c27a;text-decoration:underline;font-size:13px;cursor:pointer;padding:0;white-space:nowrap}' +
    '.ks-limit-chip{display:inline-block;margin:4px 0 6px;padding:2px 8px;border-radius:999px;background:#fdf1e1;color:#9a5b12;font-size:12px;line-height:1.6}' +
    '.ks-limit-chip.is-max{background:#f6e3c9;color:#7a420b;font-weight:600}' +
    '.ks-limit-disabled{opacity:.35;pointer-events:none}' +
    '.ks-limit-note{margin:8px 0 0;font-size:13px;color:#9a5b12}' +
    '.ks-limit-note.is-max{color:#7a420b;font-weight:600}' +
    '[data-ks-limit-reached]{background:#6f655c !important;border-color:#6f655c !important}' +
    '@media (max-width:749px){.ks-limit-toast{bottom:128px}}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  /* ---------- boot ---------- */

  function boot() {
    loadCart().catch(function () {});
    waitForMm(8000).then(function (ok) {
      if (!ok) return;
      hookMinmaxifyPopup();
      scheduleDecorate();
      scheduleReconcile();
    });
    var mo = new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var t = list[i].target;
        if (t.closest && (t.closest('cart-drawer') || t.closest('[data-cart-items], .cart'))) {
          scheduleDecorate();
          return;
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('theme:cart:change', function () { loadCart().catch(function () {}); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
